export default "__VITE_ASSET__DzFVVss6__"